/**
 * 從後台分頁 API 回應取出列表列。
 */
export const unwrapListRows = (response) => {
    const top = response?.data ?? response ?? [];
    if (Array.isArray(top)) return top;
    const nested = top?.data ?? top?.items ?? [];
    return Array.isArray(nested) ? nested : [];
};

/**
 * 從後台分頁 API 回應取出 total。
 */
export const unwrapListTotal = (response, fallback = 0) => {
    const envelope = response?.data ?? {};
    if (
        envelope &&
        typeof envelope === 'object' &&
        !Array.isArray(envelope) &&
        Array.isArray(envelope.data) &&
        envelope.total != null
    ) {
        return Number(envelope.total);
    }
    const pag = envelope.pagination ?? envelope.meta ?? response?.meta ?? {};
    return Number(
        pag.total ??
            envelope.meta?.total_count ??
            pag.total_count ??
            envelope.total ??
            fallback
    );
};

/**
 * 自動翻頁直到取完所有列（每頁最多 pageSize，預設 100）。
 */
export const fetchAllPaginatedList = async (fetchPage, pageSize = 100) => {
    let page = 1;
    let rows = [];
    let batch = [];
    let total = 0;

    do {
        const response = await fetchPage({ page, per_page: pageSize });
        batch = unwrapListRows(response);
        total = unwrapListTotal(response, batch.length);
        rows = rows.concat(batch);
        page += 1;
    } while (rows.length < total && batch.length > 0);

    return rows;
};
